import { onChangeCreator, updateWithDayOfMonth, updateWithMonthlyDayOfWeek, updateWithMonthlyInterval,
  updateWithMonthlyOccurence, updateWithMonthlyOption } 
from 'app/area/company-report/components/schedule-helpers';
import { RecurringMonthlyOptions, ScheduleFieldKeys } from 'app/area/company-report/constants';
import { SelectSingle } from 'app/area/shared/translated-components';
import * as React from 'react';
import { Numberbox } from 'ui';
import { SelectSingleRadioButton } from 'ui/select-single-short-list/select-single-radio-button/select-single-radio-button';
import styles from './report-screen.scss';

// eslint:disable-next-line: max-func-body-length
export const MonthlySchedule = ({
 setScheduleDefinition,
 scheduleDefinition,
 scheduleWeekdayOptions,
 occurenceOptions,
 translations,
 locale,
 getValidationErrors
}) => {
 
 const onChangeMonthlyDayOfMonth = onChangeCreator(updateWithDayOfMonth, setScheduleDefinition);
 const onChangeMonthlyDayOfWeek = onChangeCreator(updateWithMonthlyDayOfWeek, setScheduleDefinition);
 const onChangeMonthlyOption = onChangeCreator(updateWithMonthlyOption, setScheduleDefinition);
 const onChangeMonthlyInterval = onChangeCreator(updateWithMonthlyInterval, setScheduleDefinition);
 const onChangeMonthlyOccurence = onChangeCreator(updateWithMonthlyOccurence, setScheduleDefinition);
 const { dayOfMonth, option, monthsInterval, occurrence, dayOfWeek } = scheduleDefinition?.recurMonthly;
 const selectedMonthlyOptionValue = option?.value;
 const isSelected = (value: number): boolean => selectedMonthlyOptionValue === value;

 return <div>
 <div className={`${styles.scheduleRow}`}>
   <div className={styles.textWrapper}>
     <SelectSingleRadioButton
       componentId={`${ScheduleFieldKeys.recurMonthlyOption}-${RecurringMonthlyOptions.dayOfEveryMonth}`}
       onChange={onChangeMonthlyOption}
       isSelected={isSelected(RecurringMonthlyOptions.dayOfEveryMonth)}
       option={{ value: RecurringMonthlyOptions.dayOfEveryMonth, description: translations.day }}
       validation={getValidationErrors(ScheduleFieldKeys.recurMonthlyOption)}
     />
   </div>
   <div className={styles.numberbox}>
     <Numberbox
       componentId={ScheduleFieldKeys.recurMonthlyDayOfMonth}
       value={dayOfMonth}
       onChange={onChangeMonthlyDayOfMonth}
       className={styles.scheduleNumberbox}
       readOnly={!isSelected(RecurringMonthlyOptions.dayOfEveryMonth)}
       locale={locale}
       validation={getValidationErrors(ScheduleFieldKeys.recurMonthlyDayOfMonth)}
       maxValue={999999999}
     />
   </div>
   <div className={styles.textWrapper}>
     <span className={styles.texts}>{translations.of_every}</span>
   </div>
   <div className={styles.numberbox}>
     <Numberbox
       componentId={ScheduleFieldKeys.recurMonthlyMonthsInterval}
       value={monthsInterval}
       onChange={onChangeMonthlyInterval}
       className={styles.scheduleNumberbox}
       readOnly={!isSelected(RecurringMonthlyOptions.dayOfEveryMonth)}
       locale={locale}
       validation={getValidationErrors(ScheduleFieldKeys.recurMonthlyMonthsInterval)}
       maxValue={999999999}
     />
   </div>
   <div className={styles.textWrapper}>
     <span className={styles.texts}>{translations.months}</span>
   </div>
 </div>
 <div className={`${styles.scheduleRow}`}>
   <div className={styles.textWrapper}>
     <SelectSingleRadioButton
       componentId={`${ScheduleFieldKeys.recurMonthlyOption}-${RecurringMonthlyOptions.weekdayOfEveryMonth}`}
       onChange={onChangeMonthlyOption}
       isSelected={isSelected(RecurringMonthlyOptions.weekdayOfEveryMonth)}
       option={{ value: RecurringMonthlyOptions.weekdayOfEveryMonth, description: translations.the }}
       validation={getValidationErrors(ScheduleFieldKeys.recurMonthlyOption)}
     />
   </div>
   <div>
     <SelectSingle
       componentId={ScheduleFieldKeys.recurMonthlyOccurrence}
       onChange={onChangeMonthlyOccurence}
       className={styles.scheduleSelectSingle}
       valueItem={occurrence}
       options={occurenceOptions}
       readOnly={!isSelected(RecurringMonthlyOptions.weekdayOfEveryMonth)}
       validation={getValidationErrors(ScheduleFieldKeys.recurMonthlyOccurrence)}
     />
   </div>
   <div>
     <SelectSingle
       componentId={ScheduleFieldKeys.recurMonthlyDayOfWeek} 
       onChange={onChangeMonthlyDayOfWeek}
       className={styles.scheduleSelectSingle}
       valueItem={dayOfWeek}
       options={scheduleWeekdayOptions}
       readOnly={!isSelected(RecurringMonthlyOptions.weekdayOfEveryMonth)}
       validation={getValidationErrors(ScheduleFieldKeys.recurMonthlyDayOfWeek)}
     />
   </div>
 </div>
</div>;
};
